import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/virtual-background"
    exact
    path="/business/products/virtual-background"
    component={AsyncPage}
  />,
];
